<!-- <button (click)="openA3I()">A3I</button> -->
<div class="map-icon">
    <mat-icon class="icon-general" (click)="openA3I()" svgIcon="icon-a3i"></mat-icon>
</div>